import { ReactTFC, UnwrapReactComponent } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";

import { Link } from "react-router";
import React from "react";
import { RelatedArticleSetComponent, RelatedArticleSetComponentRightBoxProps } from "../RelatedArticleSetComponent";
import { inBoxSmallHeadline, inBoxBigHeadline } from "../shared-styles";
import { CSS_MQ } from "../../../styles/breakpoints";
import { ImageWithFocalPoint } from "../../_shared-components/image-related/ImageWithFocalPoint";
import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { T } from "../../T";

export const RelatedArticleSetRightBox: ReactTFC<RelatedArticleSetComponentRightBoxProps> = props => {
  return (
    <div
      css={css`
        color: ${CSS_COLORS.White};

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        position: relative;
        padding: 50px;
        ${CSS_MQ.atMostSm} {
          min-height: 15em;
          padding: 30px 20px;
        }

        overflow: hidden;
      `}
    >
      <Link
        to={{ pathname: props.link }}
        state={{ scrollToTop: true }}
        css={css`
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        `}
      >
        <ImageWithFocalPoint
          assetId={props.imageWithFocalPoint.image.sys.id}
          {...props.imageWithFocalPoint}
          attachStyles={css`
            z-index: -1;
            filter: brightness(0.7);
          `}
          requestedWidth={800}
        />
      </Link>

      <span css={inBoxSmallHeadline}>{props.descriptiveHeadline}</span>
      <span css={inBoxBigHeadline}>{props.emoHeadline}</span>

      <div
        css={css`
          position: relative;
          z-index: 2;

          margin-top: 20px;
          margin-bottom: 10px;

          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          ${CSS_MQ.atMostMd} {
            justify-content: center;
          }
        `}
      >
        {props.tags.map((tag, idx) => (
          <Link
            to={{ pathname: tag.link.pathname, search: tag.link.search }}
            state={{ scrollToTop: true }}
            key={idx}
            css={css`
              color: ${CSS_COLORS.White};
            `}
          >
            {tag.label}
          </Link>
        ))}
      </div>

      <span
        css={[
          FONTS.SwarovskiFutura300,
          fontSize.x2,
          css`
            color: ${CSS_COLORS.White};
            text-align: center;
          `,
        ]}
      >
        {" "}
        <T>{props.readingTime}</T>
      </span>
    </div>
  );
};
